import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';
import { DeletionStatusResponse } from '@/api/types/backend-dto-types';

const POLL_INTERVAL_MS = 4000;

/**
 * Polls the in-progress deletion (if any) for a matter. Refetches every 4s while either the
 * deletion job or the post-deletion summary-regeneration run is still in flight; stops when
 * both are idle to keep quiet pages quiet.
 */
export const useGetDeletionStatus = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DeletionStatusResponse>(
    [QueryEntity.DeletionStatus, { matterId }],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/run/matter/${matterId}/deletion-status`, fetchConfigGET);
      if (!res.ok) {
        throw new Error(`Failed to fetch deletion status: ${res.status}`);
      }
      return await res.json();
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: true,
      refetchInterval: (data) => (data?.inProgress != null || data?.hasPostDeletionRun ? POLL_INTERVAL_MS : false),
    },
  );
};
